module.exports = __webpack_public_path__ + "static/tyrant02-5d8247e622f2fea1f2ed02acb0816c33.png";